import { useTranslation } from 'react-i18next';

import { Button } from 'components/Form/Button';

export function PlaceOrderButton({
  isPlacingOrder,
  disabled,
  onClick,
}: {
  isPlacingOrder: boolean;
  disabled: boolean;
  onClick: () => void;
}) {
  const { t } = useTranslation();
  return (
    <Button
      analyticsId={'order-form-checkout-place-order'}
      size="extra-large"
      disabled={disabled}
      fullWidth
      loading={isPlacingOrder}
      onClick={onClick}
    >
      {t('orderForms:checkout.placeOrder')}
    </Button>
  );
}
